"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReanimatedBottomSheetStyles = void 0;
const react_native_1 = require("react-native");
// import DeviceInfo from 'react-native-device-info';
const react_native_device_info_1 = __importDefault(require("react-native-device-info"));
const native_1 = require("styled-components/native");
const ReanimatedBottomSheetContext_1 = require("./ReanimatedBottomSheetContext");
const utils_1 = require("./utils");
exports.useReanimatedBottomSheetStyles = () => {
    const { state: { scrollableContentHeight, snapPoints }, } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    const theme = native_1.useTheme();
    const { height: windowHeight } = react_native_1.useWindowDimensions();
    const isFullScreenTakeOver = utils_1.isHundredPercentSnapPoints(snapPoints) ||
        scrollableContentHeight >= windowHeight;
    const hasNotch = react_native_device_info_1.default.hasNotch();
    const addExtraPaddingTop = hasNotch && isFullScreenTakeOver;
    const reanimatedBottomSheetHandleStyle = {
        paddingTop: addExtraPaddingTop ? 16 : 8,
        paddingBottom: isFullScreenTakeOver ? 16 : 0,
    };
    const reanimatedBottomSheetHandleIndicatorStyle = {
        width: 40,
        backgroundColor: isFullScreenTakeOver
            ? 'transparent'
            : 'rgba(17, 17, 17, 0.14)',
    };
    const reanimatedBottomSheetBackgroundStyle = {
        borderRadius: isFullScreenTakeOver ? 0 : 14,
        ...(!isFullScreenTakeOver && {
            elevation: 9,
            shadowOpacity: 0.6,
            shadowOffset: { height: 6, width: 0 },
            shadowColor: theme.bpCore.colors.black,
            shadowRadius: 9,
        }),
    };
    return {
        reanimatedBottomSheetHandleStyle,
        reanimatedBottomSheetHandleIndicatorStyle,
        reanimatedBottomSheetBackgroundStyle,
    };
};
